import { Divider, Form, TextArea } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { PopupRGPD } from '@/components/Autre';

interface CommentairesEncaissementProps {
  /** Commentaire relatif à l'encaissement en cours. */
  commentaire: string;
  onCommentaireChange: (value: string) => void;
  /** Commentaire du payeur en cours d'édition. */
  commentairePayeur: string;
  onCommentairePayeurChange: (value: string) => void;
  /**
   * Commentaire du payeur tel qu'il vient des données, et non l'état édité : c'est lui qui
   * décide de l'affichage du second champ, sinon celui-ci disparaîtrait dès qu'on le vide.
   */
  commentairePayeurInitial?: string;
}

/**
 * Zone « Commentaires internes » d'une modale d'encaissement : commentaire de l'encaissement,
 * et historique éditable des commentaires du payeur lorsqu'il en a déjà.
 *
 * Ne rend que le `Form.Group` : le `Segment` englobant reste à la charge de l'appelant, car il
 * peut contenir d'autres blocs (le règlement par un tiers côté encaissement de facture).
 */
const CommentairesEncaissement = ({
  commentaire,
  onCommentaireChange,
  commentairePayeur,
  onCommentairePayeurChange,
  commentairePayeurInitial,
}: CommentairesEncaissementProps) => {
  const commentaireEncaissement = React.useMemo(
    () => (
      <TextArea
        rows={1}
        width={13}
        style={{ resize: 'none' }}
        onChange={({ target }) => onCommentaireChange(target.value)}
        value={commentaire}
        data-testid="textarea-commentaire"
        placeholder="Saisir un commentaire relatif à l'encaissement en cours"
      />
    ),
    [commentaire, onCommentaireChange],
  );

  return (
    <Form.Group inline style={{ width: '100%' }}>
      <Form.Field width={3}>
        <label>Commentaires internes : </label>
        <PopupRGPD />
      </Form.Field>
      {_.isEmpty(_.trim(commentairePayeurInitial)) ? (
        commentaireEncaissement
      ) : (
        <div className="text-area-group">
          {commentaireEncaissement}
          <Divider horizontal>
            <span>Historique des commentaires du payeur</span>
          </Divider>
          <TextArea
            rows={2}
            style={{ resize: 'none' }}
            onChange={({ target }) => onCommentairePayeurChange(target.value)}
            value={_.trim(commentairePayeur)}
            data-testid="textarea-commentaire-payeur"
          />
        </div>
      )}
    </Form.Group>
  );
};

export default CommentairesEncaissement;
